import React from 'react';

const OpenQuote: React.FC = () => {
  return (
    <svg width="79" height="59" viewBox="0 0 79 59" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3.81736 33.9361L30.5389 0H41.5668L22.2679 31.9398C26.0853 35.4887 27.994 39.5551 27.994 44.1391C27.994 48.1316 26.5801 51.6065 23.7525 54.5639C21.0662 57.5213 17.8143 59 13.997 59C10.1796 59 6.85711 57.5213 4.02943 54.5639C1.34314 51.6065 0 48.1316 0 44.1391C0 40.2945 1.27245 36.8935 3.81736 33.9361ZM40.2943 33.9361L67.0159 0H78.0438L58.7449 31.9398C62.5623 35.4887 64.471 39.5551 64.471 44.1391C64.471 48.1316 63.0571 51.6065 60.2294 54.5639C57.5432 57.5213 54.2913 59 50.474 59C46.6566 59 43.3341 57.5213 40.5064 54.5639C37.8201 51.6065 36.477 48.1316 36.477 44.1391C36.477 40.2945 37.7494 36.8935 40.2943 33.9361Z"
        fill="#B4FA05"
      />
    </svg>
  );
};

export { OpenQuote };
